import React from 'react';

import PropTypes from 'prop-types';

export default function CartIcon({ color = 'currentColor', size = '1em' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 28"
      fill="none"
    >
      <g clipPath="url(#bagcarticonclip09092025)">
        <path
          d="M15.9951 5.68359C15.9461 4.715 15.5315 3.79543 14.8281 3.10645C14.078 2.37183 13.0607 1.95898 12 1.95898C10.9393 1.95898 9.92199 2.37183 9.17188 3.10645C8.42173 3.84128 8 4.83871 8 5.87793V7.83691H16V5.87793L15.9951 5.68359ZM1.8457 25.6475H22.1543V9.61719H18V13.7148H16V9.61719H8V13.7148H6V9.61719H1.8457V25.6475ZM18 7.83691H24V27.4287H0V7.83691H6V5.87793C6 4.3191 6.63259 2.82394 7.75781 1.72168C8.88302 0.619509 10.4088 3.0925e-08 12 0C13.5912 0 15.117 0.619509 16.2422 1.72168C17.3674 2.82394 18 4.3191 18 5.87793V7.83691Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="bagcarticonclip09092025">
          <rect width="24" height="27.4286" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

CartIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
